import { MediaMatcher } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, HostListener, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { PageSharedFns, ShDataService } from 'src/app/services/pageSharedFunctions';
import { SharedInfo } from 'src/app/services/shared-info';
import { UserService } from 'src/app/services/user-service';
import { SharedAnimations } from 'src/app/shared/animations/shared-animations';
import Swal from 'sweetalert2';
import { AdItem } from '../../../../../models/ad-item';
import { AddEditTaskProcessComponent } from '../add-edit-taskprocess/add-edit-taskprocess.component';

import { TaskProcessService } from '../taskprocess.service';

@Component({
  selector: 'app-view-taskprocess',
  templateUrl: './view-taskprocess.component.html',
  styleUrls: ['./view-taskprocess.component.scss'],
  animations: [SharedAnimations]
})
export class ViewTaskProcessComponent extends PageSharedFns implements AfterViewInit, OnDestroy {

  form: AdItem<TaskProcessService>;
  formAddEdit: any;
  id:any;
  
  private onUnitySub;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(
    public sharedInfo: SharedInfo,
    public userService: UserService,
    public http: HttpClient,
    public dialog: MatDialog,
    public route: ActivatedRoute,
    public deviceService: DeviceDetectorService,
    public changeDetectorRef: ChangeDetectorRef,
    public media: MediaMatcher,
    private renderer: Renderer2) {
    super(dialog, route, deviceService);

    this.mobileQuery = media.matchMedia('(max-width: 600px)');

    this._mobileQueryListener = () => {
      changeDetectorRef.detectChanges();
    }


    this.route.params.subscribe(params => {
      this.tableName = 'receivables';// params['tableName'];
      this.id = params['id'];
      this.data = [];
      this.initialize();
    });
    
    this.onUnitySub = this.userService.onUnityChange.subscribe(unity=>{
      this.fetch(null);     
      setTimeout(() => {
        this.data.forEach(element => {
          element.animateChangeUnity = true;
        });
        console.log('unitChanged');
      }, 1000);
    });
  }

  ngOnDestroy() {
    this.onUnitySub.unsubscribe();
  }

  //this.onKeyUpEvent.emit(event);

  @HostListener('window:keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    this.onKeyUpEvent.emit(event.key);

    if(this.formAddEdit != null && this.formAddEdit.onKeyUpEvent != null){
      // if(this.$body.hasClass('overlay-active')) {
      //   this.formAddEdit.onKeyUpEvent.emit(event);
      // }
    }
  }


  initialize(){

    this.form = null;
    this.formAddEdit = null;
    
    this.form = new AdItem(AddEditTaskProcessComponent, new TaskProcessService(this.sharedInfo, this.userService, this.http));

    this.appService = this.form.service;
    this.columns = this.form.service.getColums();
    this.displayedColumns = [];
    this.displayedColumns = [...this.columns.map(x => x.columnDef), 'cmd'];

    this.form.onCreated.subscribe((comp) => {

      this.formAddEdit = comp;

      comp.onSaved.subscribe((dataFromAPI) => {
        console.log('dataFromAPI:', dataFromAPI);
        this.fetch(dataFromAPI);
        this.renderer.removeClass(document.body, 'overlay-active');
      });

      comp.onCancelClick.subscribe((dataFromAPI) => {
        this.renderer.removeClass(document.body, 'overlay-active');
      });

    });

    this.form.onCommandExecuted.subscribe((cmd: string) => {
      console.log('cmd:', cmd);

      switch (cmd) {

        case 'share':
          //this.clipboard.writeText(this.formAddEdit.data.id);
          break;

        case 'save':
          this.formAddEdit.submit();
          break;

        case 'delete':
          this.delete();
          break;

        default:
          break;
      }
    });

    if(this.id) {
      //Auto edit mode, get ID from URL
      this.openEdit(this.id);
    }
  }

  setCommands(edit: boolean = false){
    this.form.commands = [];
    this.form.commands.push({ cmd: 'share', icon: 'share', label: '' });
    this.form.commands.push({ cmd: 'save', icon: 'save', label: '' });


    this.form.moreCommands = [];
    if(edit == true)
    {
      this.form.moreCommands.push({ cmd: 'delete', icon: 'delete', label: 'Excluir Registro' });
    }
  }


  openEdit(id) {
    this.setCommands(true);
    this.selectedItem = this.data.find(i=>i.id == id);
    this.appService.getItemDetails(id).subscribe(ret => {
      this.form.data = ret.data;
      this.form.component.prototype.idForEdit = ret.data.id;
      //this.form.component.prototype.tableName = this.tableName;
      this.sharedInfo.onSetComponent.emit(this.form);
      this.renderer.addClass(document.body, 'overlay-active');
    }, errRersp => {

    });

  }


  addItem() {
    this.setCommands(false);
    this.form.data = null;
    this.form.component.prototype.idForEdit = null;
    //this.form.component.prototype.tableName = this.tableName;
    this.sharedInfo.onSetComponent.emit(this.form);
    this.renderer.addClass(document.body, 'overlay-active');
  }

  delete() {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-danger',
        cancelButton: 'btn'
      },
      buttonsStyling: false
    })

    swalWithBootstrapButtons.fire({
      position: 'top',
      title: "Confirmar Exclusão",
      text: "Confirma a exclusão do registro ?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sim, Excluir',
      cancelButtonText: 'Não',
      reverseButtons: true
    }).then((result) => {

      if (result.value) {
        this.appService.delete(this.selectedItem.id).subscribe(ret => {
          if (ret.success == true) {
            this.selectedItem = this.data.find(i=>i.id == this.selectedItem.id);

            console.log(this.selectedItem);
            console.log('index', this.data.indexOf(this.selectedItem));

            this.data.splice(this.data.indexOf(this.selectedItem), 1);
            this.data = [... this.data];

            this.renderer.removeClass(document.body, 'overlay-active');
          }
        });
      }

    })
  }
}
